import application_settings from '../applicationSettings';
import modules from '../modules';
import LocalStorage from '../local_data';
import Event from './Event';
//import plupload from 'plupload';

class UserChangeProfileImage extends Event {
    eventName = 'oms_userChangeProfileImage';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for change profile image
     * 
     * @param {string} data.name -  image name given for customer image
     * @param {string} data.photo -  photo for customer
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let name = data.name;
        let photo = data.photo;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let multiCallKey = (data.multi_call_key) ? data.multi_call_key : '';

        if (clientId && name && photo) {
            let request = new modules.Request();

            // let userDetails = new LocalStorage.UserDetails(clientId).getData();
            // let userToken = userDetails.data.access_token;

            // /* Start Pluploader Script  */
            // var uploader = new plupload.Uploader({
            //     runtimes: 'html5',

            //     browse_button: 'pickfiles', // you can pass in id...
            //     container: document.getElementById('profile-button'), // ... or DOM Element itself

            //     url: application_settings.endPoints.userChangeProfilePicture,
            //     headers: {
            //         "Authorization": 'Bearer ' + userToken
            //     },
            //     filters: {
            //         /*max_file_size: '5mb',*/
            //         mime_types: [{
            //             title: "Image files",
            //             extensions: "jpg,JPG,jpeg,JPEG,png,PNG"
            //         }]
            //     },
            //     resize: {
            //         width: 300,
            //         height: 300,
            //         preserve_headers: false
            //     },
            //     file_data_name: 'photo',
            //     multi_selection: false,
            //     // Flash settings
            //     flash_swf_url: 'plupload/js/Moxie.swf',

            //     // Silverlight settings
            //     silverlight_xap_url: 'plupload/js/Moxie.xap',

            //     init: {

            //         FilesAdded: function (up, files) {
            //             //auto start the upload after file is added
            //             uploader.start();
            //             console.log(11111);
            //         },
            //         FileUploaded: function (up, file, info) {
            //             let response = JSON.parse(info.response);
            //             console.log(response);
            //         }
            //     }
            // });

            var formdata = new FormData();
            formdata.append("photo", photo);

            request.send({
              endPoint: application_settings.endPoints.userChangeProfilePicture,
              method: "POST",
              data: formdata,
              contentType: false,
              processData: false,
              authenticate: true,
              client_id: clientId,
              canUsePublicAuth: false,
              multiCallKey: multiCallKey,
              onSuccess: function (response, status) {
                //format response data
                let data = thisObj.formatResponseData(response);
                //fire success event
                thisObj.onSuccessEvent(data, {
                  action: action,
                  request_id: requestId,
                });
              },
              onError: function (jqXHR, textStatus, errorThrown) {

                //fire error event
                thisObj.onErrorEvent(
                  { message: textStatus.statusText, status: textStatus.status },
                  { action: action, request_id: requestId }
                );
              },
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id & name & photo is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }


}

export default UserChangeProfileImage;